import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {connect} from 'store';
import {getSegmentsForCaptions} from 'store/element-list/selectors';
import Sentence from './sentence';

export class Captions extends Component {
    static propTypes = {
        fontSize: PropTypes.string,
        segments: ImmutablePropTypes.list.isRequired,
        highlightTokensByTime: PropTypes.bool.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.segments !== this.props.segments
            || nextProps.highlightTokensByTime !== this.props.highlightTokensByTime;
    }

    render() {
        const {segments, highlightTokensByTime} = this.props;
        return (
            <div className='cielo24-vwrap-captions'>
                {segments.map(segment => (
                    <Sentence
                        key={segment.get('startTime')}
                        fontSize={this.props.fontSize}
                        segment={segment}
                        showSpeaker={false}
                        showTimestamp={false}
                        showSearchResults={false}
                        highlightTokensByTime={highlightTokensByTime}
                    />
                ))}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    segments: getSegmentsForCaptions(state),
    highlightTokensByTime: state.config.get('wordHighlight'),
});

export default connect(mapStateToProps)(Captions);



// WEBPACK FOOTER //
// ./scripts/components/transcript/captions.js